export default __webpack_public_path__ + "static/media/private-label.03275f23.jpg";